// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const $ = jQuery;

$.fn.extend({
  captcha(options) {
    let settings = { imageUrl: '' };

    settings = $.extend(settings, options);

    return this.each(function () {
      const container = $(this);
      const idField = container.find('#captcha_id');
      const answerField = container.find('#captcha_answer');
      const image = createImageTag(container, answerField);
      refreshImage(idField, image, settings);
      return enableRefreshLink(container, idField, image, settings);
    });
  },
});

var createImageTag = function (container, answerField) {
  const imageTag = $('<img />');
  imageTag.load(() => showCaptcha(container, answerField));
  container.find('#captcha_image').append(imageTag);
  return imageTag;
};

var refreshImage = function (idField, image, settings) {
  const id = Math.floor(Math.random() * 1000000000);
  idField.val(id);
  return image.attr('src', `${settings.imageUrl}${id}`);
};

var enableRefreshLink = function (container, idField, image, settings) {
  const link = container.find('a');
  return link.click(function () {
    refreshImage(idField, image, settings);
    sendCaptchaRefresh();
    return false;
  });
};

var showCaptcha = function (container, answerField) {
  container.show();
  return answerField.attr('required', 'required');
};

var sendCaptchaRefresh = () =>
  $.ajax({
    type: 'POST',
    url: '/feedback/client_event',
    data: __guardMethod__(JSON, 'stringify', (o) =>
      o.stringify({ name: 'captcha.try_different', payload: {} })
    ),
    dataType: 'json',
    contentType: 'application/json',
  });
function __guardMethod__(obj, methodName, transform) {
  if (
    typeof obj !== 'undefined' &&
    obj !== null &&
    typeof obj[methodName] === 'function'
  ) {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}
